/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface IdNameResultOfint
 */
export interface IdNameResultOfint {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof IdNameResultOfint
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof IdNameResultOfint
     */
    name: string;
}

/**
 * Check if a given object implements the IdNameResultOfint interface.
 */
export function instanceOfIdNameResultOfint(value: object): value is IdNameResultOfint {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IdNameResultOfintFromJSON(json: any): IdNameResultOfint {
    return IdNameResultOfintFromJSONTyped(json, false);
}

export function IdNameResultOfintFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdNameResultOfint {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
    };
}

export function IdNameResultOfintToJSON(json: any): IdNameResultOfint {
    return IdNameResultOfintToJSONTyped(json, false);
}

export function IdNameResultOfintToJSONTyped(value?: IdNameResultOfint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
    };
}

